import React from 'react'

function A3() {
    return (
        <div>
            <h1>Great!</h1>
        </div>
    )
}

export default A3

